import React from 'react';
import { SearchOff } from '@mui/icons-material';
import { grey } from '@mui/material/colors';
import { Stack, Typography } from '@mui/material';
import { PageContainer } from 'components/shared/Page/PageContainer';

export const NotFound = () => {
  return (
    <PageContainer title="Page Not Found">
      <Stack alignItems="center" justifyContent="center" height="80vh" spacing={2}>
        <SearchOff sx={{ color: grey['600'], fontSize: '8rem' }} />

        <Typography sx={{ fontSize: '2.25rem' }} variant="h6" component="span" color="textSecondary">
          Page Not Found
        </Typography>

        <Typography variant="body1" color="textSecondary">
          The page you are looking for does not exist.
        </Typography>
      </Stack>
    </PageContainer>
  );
};
